import { Reveal } from "../lib/motion";

export default function SectionHeading({ eyebrow, title, subtitle, dark = false, align = "left", max = "max-w-2xl" }) {
  const alignCls = align === "center" ? "mx-auto text-center items-center" : "items-start";
  return (
    <div className={`flex flex-col ${alignCls} ${max}`}>
      {eyebrow && (
        <Reveal>
          <span className="overline accent-text">{eyebrow}</span>
        </Reveal>
      )}
      <Reveal delay={0.06}>
        <h2 className={`mt-4 font-display text-4xl font-medium tracking-tight sm:text-5xl ${dark ? "text-white" : "text-[#07111F]"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.12}>
          <p className={`mt-4 text-base leading-relaxed md:text-lg ${dark ? "text-slate-400" : "text-slate-500"}`}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
